import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import OnDemand from "../../../assets/img/Featured/app-ondemand.png";
import Service from "../../../assets/img/Featured/app-service.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const GuestPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash guestPage">
            <Header />
            <div className="page-header">Hotel</div>
            <div className="background" />
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Guest Rooms</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                Whether it's room readiness, a late meal
delivered to their room, more bathroom towels or
a broken TV, you need the right tools to
seamlessly and efficiently meet your guests' in-room requirements.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Guest Rooms & Housekeeping", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <img src={OnDemand} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Guest Rooms & Housekeeping", "Service");
                    addFlow("Service");
                    navigate("/solutions/service")}}>
                    <img src={Service} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Service
                    </div>
                    
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default GuestPage;